import { notifications } from '@mantine/notifications';
import { errorCopy } from '../api/errors';

/**
 * Feedback that names what happened.
 *
 * A bare "Saved" toast is the software equivalent of a shrug: it confirms that *something*
 * happened without confirming it was the thing you meant. Every call here takes the subject, so
 * the user reads "Updated McKenzie Taylor" and can catch a mistake immediately.
 */
export function notifySaved(what: string) {
  notifications.show({ title: 'Saved', message: what, color: 'teal' });
}

export function notifyDone(title: string, message: string) {
  notifications.show({ title, message, color: 'teal' });
}

/** A caller-owned, localized problem whose copy must not be replaced by the English API catalog. */
export function notifyProblem(title: string, message: string) {
  notifications.show({ title, message, color: 'red', autoClose: 8000 });
}

/**
 * A SAVE THAT WENT THROUGH AND IS STILL WORTH A LOOK.
 *
 * Some doors answer 200 with a question beside the row. Pinning a lempira price is the one that
 * forced this: type L50 next to a $3.00 beer and the server accepts it — it must, because the
 * owner's own published card states "$2 / 50 Lempira" — but it answers with a sentence asking
 * whether that was a promotional price or a rate he meant to lock. That sentence was written,
 * tested and documented, and then displayed nowhere: the portal saves through one shared component
 * which read the status and threw the body away. A warning nobody sees is not a warning.
 *
 * Yellow, and it does not close on its own, because it is a question and it is his to answer.
 */
export function notifyWarnings(warnings: readonly { message: string }[]) {
  for (const w of warnings) {
    notifications.show({
      title: 'Saved — worth a look',
      message: w.message,
      color: 'yellow',
      autoClose: false,
    });
  }
}

/** Turns any thrown value into something worth reading. See api/errors.ts for the mapping. */
export function notifyError(err: unknown, action?: string) {
  const { title, message } = errorCopy(err, action);
  notifications.show({ title, message, color: 'red', autoClose: 8000 });
}
